import { useFmsNotificationsContextIfPresent } from 'context/FmsNotificationsContext'
import { useEffect } from 'react'

/**
 * Suppress auto-open of the header notification sandwich while `active`.
 * Inbox and the bell badge still update. Pass a stable reason from
 * `NOTIFICATION_SANDWICH_SUPPRESS` (or any new string).
 *
 * Safe outside FmsNotificationsProvider (no-op).
 */
export function useSuppressNotificationSandwich(active: boolean, reason: string) {
  const ctx = useFmsNotificationsContextIfPresent()
  useEffect(() => {
    if (!ctx || !active || !reason) {
      return
    }
    ctx.acquireSandwichSuppress(reason)
    return () => ctx.releaseSandwichSuppress(reason)
  }, [ctx, active, reason])
}
